import { render, staticRenderFns } from "./inventory-lots.html?vue&type=template&id=1e01841e&scoped=true&"
import script from "./inventory-lots.ts?vue&type=script&lang=js&"
export * from "./inventory-lots.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e01841e",
  null
  
)

export default component.exports